export { default } from './spinner'